<template>
  <div>
    <!--    内容分发-->
    <div class="content-item flex">
      <p>
        <span class="red">*</span>{{ distributeInformationFloor.floorDesc }}
      </p>
      <el-radio-group
        v-model="distributeExtension"
        class="flex align-items-center radio-item"
        v-for="(
          radioItem, id
        ) in distributeInformationFloor.contentAttributeBizDTOS"
        :key="id"
        @change="distributeChange"
      >
        <el-radio
          :label="radioItem.id"
          :disabled="radioItem.disable || articelDisabled"
          >{{ radioItem.desc }}</el-radio
        >
      </el-radio-group>
    </div>
    <div class="content-item flex" v-if="distribute">
      <p style="visibility: hidden"><span class="red">*</span></p>
      <el-radio-group
        v-model="extensionSecondLevel"
        class="flex align-items-center radio-item"
        v-for="(item, index) in distributeChildren"
        :key="index"
      >
        <el-radio
          :label="item.id"
          :disabled="item.disabled || articelDisabled"
          >{{ item.desc }}</el-radio
        >
      </el-radio-group>
    </div>
    <!-- 内容索引 -->
    <div class="content-item flex flexCenter">
      <p>
        <span class="red" v-if="sourceType !== 10 && sourceType !== 11">*</span
        >内容索引
      </p>
      <el-cascader
        v-model="indexSelect"
        :disabled="articelDisabled"
        :props="indexProps"
        :options="indexTreeList"
        @change="handleChange"
      ></el-cascader>
    </div>
    <!--内容质量-->
    <div class="content-item flex flexCenter">
      <!-- <p> -->
      <!-- <span class="red">*</span> -->
      <!-- {{ natureInformationFloor.floorDesc }}
      </p>
      <el-radio-group
        v-model="natureExtension"
        class="flex align-items-center radio-item"
        v-for="(
          radioItem, id
        ) in natureInformationFloor.contentAttributeBizDTOS"
        :key="id"
        @change="natureChange"
      >
        <el-radio
          :label="radioItem.id"
          :disabled="radioItem.disable || articelDisabled"
          >{{ radioItem.desc }}</el-radio
        >
      </el-radio-group> -->
      <!-- <div style="display: flex; align-items: center;"> -->
      <p>内容质量</p>
      <el-radio-group v-model="natureExtension">
        <el-radio
          v-for="item in allTypeList"
          :key="item.id"
          :label="item.code"
          @change="testLever(item, item.code)"
          >{{ item.desc }}</el-radio
        >
      </el-radio-group>
      <!-- <div v-for="(text, index) in typeList" :key="text.id" style="margin-left: 5px; ">
              <span v-if="text.checked">：{{ text.desc }}</span>
              <span v-else-if="index == typeList.length -1">：{{ tipTool }}</span>
          </div> -->
      <div v-if="natureExtension === 100">
        <span style="vertical-align: text-bottom">：{{ tipTool }}</span>
      </div>
    </div>
    <!-- </div> -->
    <div class="content-item flex flexCenter">
      <p style="visibility: hidden"><span class="red">*</span></p>
      <el-radio-group
        v-model="natureSecondLevel"
        class="flex align-items-center radio-item"
        v-for="(item, index) in natureChildren"
        :key="index"
      >
        <el-radio
          :label="item.id"
          :disabled="item.disabled || articelDisabled"
          >{{ item.desc }}</el-radio
        >
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import { getContentAttribute } from "@/api/questionsLibrary";
import { manListContentIndexTree } from "@/api/indexs";
export default {
  name: "contentLabelInfo",
  props: ["contentId", "sourceType", "contentType", "articleIndex"],
  data() {
    return {
      distributeInformationFloor: {}, // 内容分发楼层的信息
      natureInformationFloor: {}, // 内容性质楼层信息
      distributeChildren: [], // 内容分发二级楼层信息
      natureChildren: [], // 内容性质二级楼层信息
      distributeExtension: 26, // 分发一级选择值
      extensionSecondLevel: 28, // 分发二级选择值
      natureExtension: 100, // 性质一级选择值
      natureSecondLevel: 20, // 性质二级选择值
      distribute: true, // 控制推广展示
      indexTreeList: [], // 内容索引下拉级联选项展示
      indexProps: {
        // 内容索引props展示
        value: "indexId",
        label: "name",
        children: "contentIndexes",
      },
      allTypeList: [],
      typeList: [],
      checkFinal: [],
      tipTool: "",
    };
  },
  watch: {},
  computed: {
    indexSelect: {
      get() {
        return this.articleIndex;
      },
      set(val) {
        this.$emit("update:articleIndex", val);
      },
    },
  },
  mounted() {
    this.getInformationFloor();
    this.getIndexTreeList();
  },
  methods: {
    // 获取内容分发楼层
    getInformationFloor() {
      getContentAttribute({
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.contentId,
        contentType: this.contentType,
      }).then((res) => {
        if (res) {
          let arr = [{ code: 100, id: 100, desc: "系统判断" }];
          this.distributeInformationFloor = res[0]; // 分发
          this.natureInformationFloor = res[1]; // 性质
          // 处理最终质量数据
          res[1].contentAttributeBizDTOS.map((item) => {
            if (["2", "3", "4"].includes(item.code)) {
              this.typeList.push(item);
              if (item.checked) {
                this.natureExtension = 100;
              }
            } else {
              if (item.checked) {
                this.natureExtension = item.code;
              }
              arr.unshift(item);
            }
          });
          const val = this.typeList.filter((item) => item.checked);
          this.tipTool = val.length > 0 ? val[0].desc : "暂无";
          this.allTypeList = arr;
          // this.natureInformationFloor?.contentAttributeBizDTOS?.forEach((item) => {
          //   if (item.checked) {
          //     this.natureExtension = item.id;
          //   }
          // })
          this.distributeChildren =
            res[0].contentAttributeBizDTOS[0].children || []; // 分发子级
          this.natureChildren =
            res[1].contentAttributeBizDTOS[0].children || []; // 性质子级
          // 内容分发处理
          res[0].contentAttributeBizDTOS.map((item) => {
            if (item.disable) {
              this.distributeExtension = 27;
              this.extensionSecondLevel = null;
              this.distributeChildren = []; // 分发子级
              this.distribute = false;
            }
            if (item.checked) {
              this.distributeExtension = item.id;
              // 用于回显
              if (item.id == 26) {
                this.extensionSecondLevel =
                  item.children.filter((i) => i.checked)[0]?.id || 28;
              }
            } else {
              this.distributeExtension = 26;
            }
          });
          if (this.distributeExtension == 27) {
            this.distribute = false;
          }
          // 父组件控制展示和隐藏使用
          this.$emit("distribute-change", this.distribute);
          // 内容性质处理
          res[1].contentAttributeBizDTOS.map((item) => {
            if (item.checked) {
              // this.natureExtension = item.id;
              if (item.id != 18) {
                this.natureChildren = [];
              } else {
                this.natureSecondLevel = item.children.filter(
                  (item) => item.checked
                )[0].id;
              }
            }
          });
          // 内容性质未被选中，针对主站问答来源的默认处理
          const noChecked = res[1].contentAttributeBizDTOS.every(
            (item) => !item.checked
          );
          if (noChecked) {
            if (this.sourceType === 10) {
              // 若为主站问答，默认选中种草攻略
              // this.natureExtension = 24;
              this.natureChildren = [];
              this.natureSecondLevel = undefined;
            }
          }
          console.log(noChecked, this.sourceType, this.natureExtension);
        }
      });
    },
    // 内容分发选择
    distributeChange(val) {
      if (val == 27) {
        this.extensionSecondLevel = null;
        this.distribute = false;
      } else {
        this.distribute = true;
        this.extensionSecondLevel = 28;
      }
      this.$emit("distribute-change", this.distribute);
      this.distributeInformationFloor.contentAttributeBizDTOS.map((item) => {
        if (val == item.id) {
          this.distributeChildren = item.children || [];
        }
      });
    },
    // 内容性质选择
    natureChange(val) {
      if (val != 18) {
        this.natureSecondLevel = null;
      } else {
        this.natureSecondLevel = 20;
      }
      this.natureInformationFloor.contentAttributeBizDTOS.map((item) => {
        if (val == item.id) {
          this.natureChildren = item.children || [];
        }
      });
    },

    // 最终质量的选择
    testLever(item, code) {
      // console.log("item",item,code)
      // let arr = [item];
      // if(code == 100) {
      //   arr = this.typeList.filter(item => item.checked);
      // }
      // console.log("arrarrraarr",arr)
      this.natureExtension = code;
    },
    dataProcessing() {
      let arr = [];
      // 分发数据处理
      this.distributeInformationFloor.contentAttributeBizDTOS.map((item) => {
        if (this.distributeExtension == item.id) {
          let parent = {
            code: item.code,
            type: item.type,
          };
          arr.push(parent);
        }
        if (item.children) {
          item.children.map((childItem) => {
            if (this.extensionSecondLevel == childItem.id) {
              let children = {
                code: childItem.code,
                type: childItem.type,
              };
              arr.push(children);
            }
          });
        }
      });
      // 性质数据处理
      this.natureInformationFloor.contentAttributeBizDTOS.map((item) => {
        if (this.natureExtension == item.code) {
          let parent = {
            code: item.code,
            type: item.type,
          };
          arr.push(parent);
        }
        if (item.children) {
          item.children.map((childItem) => {
            if (this.natureSecondLevel == childItem.id) {
              let children = {
                code: childItem.code,
                type: childItem.type,
              };
              arr.push(children);
            }
          });
        }
      });
      arr = [...arr, ...this.checkFinal];
      return arr;
    },
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    handleChange(val) {
      this.$emit("indexChange", val);
    },
    getIndexTreeList(contentId) {
      manListContentIndexTree({ contentId: this.contentId }).then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.$parent.getDiseaseInfoDraftDetail().then(() => {
          console.log(this.$parent?.res, 999);
          if (this.$parent?.res?.contentIndexes?.length > 0) {
            const treeToArr = (obj, arr) => {
              if (obj && obj.indexId) {
                arr.push(obj.indexId);
                treeToArr(obj.contentIndexes[0], arr);
              }
              if (
                !obj ||
                !obj.contentIndexes ||
                obj.contentIndexes.length === 0
              ) {
                return arr;
              }
            };
            if (this.$parent?.res?.contentIndexes?.length > 0) {
              const arr = [];
              treeToArr(this.$parent?.res.contentIndexes[0], arr);
              this.indexSelect = arr;
            }
          }
        });
        this.indexTreeList = res;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content-item p {
  width: 107px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;

  span {
    color: #f62458;
    margin-right: 5px;
  }
}
.radio-item {
  margin-left: 10px;
}
:deep(.content-item) {
  min-width: auto !important;
}

.flexCenter {
  display: flex;
  align-items: center;
}
</style>
